module.exports = __webpack_public_path__ + "static/media/chatIconList.ab32fc63.svg";